import { useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { useState, useEffect } from "react";
import { Disclosure } from "@headlessui/react";
import { useNavigate } from "react-router-dom";
import { useTranslation, Trans } from "react-i18next";

import { useBreadcrumb } from "hooks/useBreadcrumb";
import {
  isAllowedToMakeCCPayment,
  isFlagEnabled,
  isOldAlicUlPolicy,
  isPolicyInactiveByPolicyStatus,
} from "js/utilities";
import { getName, stringFormattingToCurrency } from "js/formatting";
import getPaymentUID from "service/paymentServices/getPaymentUID";
import { depricated_getPaymentProfile } from "service/paymentServices/depricated_getPaymentProfile";

import ConfirmModal from "components/ModalDialogs/ConfirmModal";
import DeprecatedPanelTwo from "components/Payments/MakeAPayment/DeprecatedPanelTwo";
import DeprecatedPanelOne from "components/Payments/MakeAPayment/DeprecatedPanelOne";
import DeprecatedPanelThree from "components/Payments/MakeAPayment/DeprecatedPanelThree";
import GeneralPurposeDialog from "components/General/GeneralPurposeDialog";
import EverlakeLoadingOverlay from "components/General/EverlakeLoadingOverlay";
import AddPaymentMethodModal from "components/ModalDialogs/AddPaymentMethodModal";
import DeleteAutopayPaymentModal from "components/ModalDialogs/DeleteAutopayPaymentModal";
import DeleteNonAutopayPaymentModal from "components/ModalDialogs/DeleteNonAutopayPaymentModal";
import AuthedCustomerAuthorizePaymentModal from "components/ModalDialogs/AuthedCustomerAuthorizePaymentModal";

import Toast from "components/General/Toast";
import AuthorizePaymentNameValidationModal from "components/ModalDialogs/AuthorizePaymentNameValidationModal";
import PanelTwo from "components/Payments/MakeAPayment/PanelTwo";
const DeprecatedMakeAPayment = () => {
  let navigate = useNavigate();
  const { policies } = useSelector((state) => state.data);
  const { csrUser } = useSelector((s) => s.csrUser);
  const { user } = useSelector((s) => s.user);
  const {
    register,
    setValue,
    trigger,
    handleSubmit,
    control,
    resetField,
    getValues,
    formState: { errors },
  } = useForm({
    mode: "all",
    defaultValues: "",
  });
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const [title, setTitle] = useState();
  const [disc, setDisc] = useState();
  const [procStatus, setProcStatus] = useState();
  const [txRefNum, setTxRefNum] = useState();
  const [amount, setAmount] = useState();
  const [cardData, setCardData] = useState([]);
  const [useCustomerRefNum, setUseCustomerRefNum] = useState();
  const [selectedCard, setSelectedCard] = useState("newcard");
  const [userValErrorModalState, setUserValErrorModalState] = useState(false);
  const [policyNumber, setPolicyNumber] = useState();
  const [currentStep, setCurrentStep] = useState(1);
  const [policy, setPolicy] = useState();
  const [payment, setPayment] = useState();
  const [date, setDate] = useState(null);
  const [fullName, setFullName] = useState();
  const [config, setConfig] = useState("Add");
  const [addPaymentModal, setAddPaymentModal] = useState(false);
  const [authorizeModal, setAuthorizeModal] = useState(false);
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [deleteAutopayPaymentModal, setDeleteAutopayPaymentModal] =
    useState(false);
  const [deleteNonAutopayPaymentModal, setDeleteNonAutopayPaymentModal] =
    useState(false);
  const [uid, setUid] = useState();
  const [isRequierd, setIsRequierd] = useState();
  const [selectedPolicy, setSelectedPolicy] = useState();
  const [isDisabled, setIsDisabled] = useState(true);
  const [loan, setLoan] = useState();
  const [paymentType, setPaymentType] = useState();
  const [isStepTwoChecked, setStepTwoChecked] = useState(false);
  const onSubmit = () => {
    setAddPaymentModal(false);
    setConfirmationModal(true);
  };
  const cancel = () => {
    navigate("/policies", { replace: true });
  };

  const [
    creditCardValidationCheckModalState,
    setCreditCardValidationCheckModalState,
  ] = useState(false);
  const [toastDetail, setToastDetail] = useState({
    title: "title",
    message: "message",
    type: undefined,
  });

  useEffect(() => {
    depricated_getPaymentProfile(user.userId).then((response) => {
      let paymentProfile = [];
      response.map((p) => {
        if (p.cardStatus?.toLowerCase() !== "expired") {
          paymentProfile.push({
            name: p.cardType,
            lastFour: p.cardNumber,
            isDefault: false,
            paymentProfileId: p.paymentProfileId,
            cardStatus: p.cardStatus,
          });
        }
      });
      setCardData(paymentProfile);
    });
  }, [user]);
  async function advanceModal() {
    if (!csrUser?.userId) {
      if (isFlagEnabled("ENABLE_NAME_VALIDATION_ON_AUTHORIZE_PAYMENT_MODAL")) {
        setCreditCardValidationCheckModalState(true);
      } else {
        if (
          parseFloat(getValues("amount").replace("$", "").replace(",", "")) > 0
        ) {
          if (policyNumber && fullName && user?.userId) {
            let selectedPolicy = policies.find(
              (x) => x.contractID === policyNumber
            );
            if (selectedCard === "newcard") {
              setIsLoading(true);
              let response = await getPaymentUID(
                stringFormattingToCurrency(
                  getValues("amount").replace("$", "").replace(",", "") ??
                    amount
                ),
                `${policyNumber}`,
                `${fullName}`,
                "customer",
                `${user.userId}`,
                `${selectedPolicy?.blockCode}`
              ).catch((error) => {
                console.log(error);
                setIsLoading(false);
                setTitle(t("MakePayment-errorTitle1"));
                setDisc(t("MakePayment-errorSubTitle1"));
                setUserValErrorModalState(true);
              });
              if (response?.uid) {
                setIsLoading(false);
                setUid(response?.uid);
                setAuthorizeModal(true);
                setConfirmationModal(false);
              } else {
                setIsLoading(false);
                //display user friendly error message to user
                setTitle(t("MakePayment-errorTitle1"));
                setDisc(t("MakePayment-errorSubTitle1"));
                setUserValErrorModalState(true);
              }
            } else {
              let selectCardNum = cardData.find(
                (x) => x.lastFour === getValues("selectedCard")
              );
              setIsRequierd(true);
              setSelectedCard(selectCardNum?.lastFour);
              setUseCustomerRefNum(selectCardNum?.paymentProfileId);
              setAmount(
                getValues("amount").replace("$", "").replace(",", "") ?? amount
              );
              setAuthorizeModal(true);
              setConfirmationModal(false);
            }
          } else {
            setTitle(t("MakePayment-errorTitle1"));
            setDisc(t("MakePayment-errorSubTitle1"));
            setUserValErrorModalState(true);
          }
        } else {
          setTitle(t("MakePayment-errorTitle2"));
          setDisc(t("MakePayment-errorSubTitle2"));
          setUserValErrorModalState(true);
        }
      }
    } else {
      setTitle("CSR validation error");
      setDisc("Customer service representative user can not make a payment.");
      setUserValErrorModalState(true);
    }
  }
  const dataSubmit = (data) => {
    if (data?.policy) {
      let seletePolicy = policies.find((x) => x.contractID === data?.policy);
      setSelectedPolicy(seletePolicy);
      setFullName(() => {
        let primaryOwner = seletePolicy?.parties?.find(
          (x) => x.person?.taxId === user.identityNumber
        );
        return getName(primaryOwner?.person);
      });
    }
    if (data) {
      if (data?.policy) setPolicyNumber(data.policy);
      if (data?.selectedCard) setSelectedCard(data.selectedCard);
    }
  };
  useEffect(() => {
    setPolicy(
      policies.find(
        (x) => x.contractID && isAllowedToMakeCCPayment(x, "onetimepayment")
      )
    );
  }, [policies]);

  useBreadcrumb([
    { name: t("CustomerManagePayment-home"), url: "/policies" },
    { name: t("CustomerManagePayment-payments"), url: "/payment" },
    { name: t("MakePayment-title"), url: "#" },
  ]);

  return (
    <>
      <EverlakeLoadingOverlay isLoading={isLoading}>
        <div className="flex flex-col flex-grow">
          <div className="border border-transparent">
            <div className="container mb-8">
              <h1>{t("MakePayment-title")}</h1>
              {config.COMPANY_NAME === "everlake" && (
                <Trans defaults={t("MakePayment-desc")} />
              )}
              <hr />
            </div>

            {toastDetail.type && (
              <div className="ui-component-spacing">
                <Toast {...toastDetail} />
              </div>
            )}

            <div className="container mb-8">
              <div className="ui-form-make-payment container">
                {/* <!-- Step 1 --> */}
                <div
                  id="ID_paymentStep1"
                  className="flex flex-row md:ml-8 md:mr-0 lg:ml-20 xl:ml-28 lg:pr-16"
                >
                  <div className="w-8 md:flex md:flex-col md:justify-center md:mr-14">
                    <div className="flex justify-center items-center mt-6 mb-4">
                      <div
                        id="ID_paymentStep1Number"
                        className={`inline-flex justify-center items-center h-8 w-8 text-white ${
                          currentStep >= 1
                            ? "bg-ui-blue-dark"
                            : "bg-ui-gray-medium-dark"
                        } rounded-full overflow-hidden`}
                      >
                        1
                      </div>
                    </div>
                    <div className="flex h-full w-px bg-ui-gray-medium-light mx-auto overflow-hidden"></div>
                  </div>

                  <div className="w-full flex-grow">
                    {/* <!-- Step 1 Card --> */}

                    <div className="ui-card relative px-4 py-4 mb-6 lg:px-6">
                      <Disclosure as="div">
                        {({ open }) => (
                          <>
                            <div>
                              <div className="flex justify-between items-start">
                                <h2 className="flex flex-grow font-body font-bold text-xl">
                                  {t("MakePayment-stepTitle5")}
                                </h2>
                                <div className="font-semibold text-sm whitespace-nowrap">
                                  {t("MakePayment-step1")}
                                </div>
                              </div>
                            </div>

                            <div
                              id="ID_paymentStep1Options"
                              className="pt-4 mt-2 lg:pt-6 border-t border-theme-rule-light"
                            >
                              <Disclosure.Panel
                                static
                                className="pb-2 text-sm text-gray-500"
                              >
                                <DeprecatedPanelOne
                                  panelOneSelection={policy}
                                  setPanelOneSelection={setPolicy}
                                  setPanelTwoSelection={setPayment}
                                  dataArray={policies?.filter(
                                    (p) =>
                                      isAllowedToMakeCCPayment(
                                        p,
                                        "onetimepayment"
                                      ) &&
                                      !isPolicyInactiveByPolicyStatus(p?.status)
                                  )}
                                  register={register}
                                  setCurrentStep={setCurrentStep}
                                  handleSubmit={handleSubmit}
                                  dataSubmit={dataSubmit}
                                  setValue={setValue}
                                  setSelectedPolicy={setSelectedPolicy}
                                  setIsDisabled={setIsDisabled}
                                  setStepTwoChecked={setStepTwoChecked}
                                />
                              </Disclosure.Panel>
                            </div>
                          </>
                        )}
                      </Disclosure>
                    </div>
                  </div>
                </div>

                {/* <!-- Step 2 --> */}
                <div
                  id="ID_paymentStep2"
                  className="flex flex-row md:ml-8 md:mr-0 lg:ml-20 xl:ml-28 lg:pr-16"
                >
                  <div className="w-8 md:flex md:flex-col md:justify-center md:mr-14">
                    <div className="flex justify-center items-center mt-3 mb-4">
                      <div
                        id="ID_paymentStep2Number"
                        className={`inline-flex justify-center items-center h-8 w-8 text-white ${
                          currentStep >= 2
                            ? "bg-ui-blue-dark"
                            : "bg-ui-gray-medium-dark"
                        } rounded-full overflow-hidden`}
                      >
                        2
                      </div>
                    </div>
                    <div className="flex h-full w-px bg-ui-gray-medium-light mx-auto overflow-hidden"></div>
                  </div>
                  {/* <!-- Card 2 --> */}

                  <div className="w-full flex-grow">
                    <div className="ui-card relative px-4 py-4 mb-6 lg:px-6">
                      <Disclosure as="div">
                        {({ open }) => (
                          <>
                            <div>
                              <div className="flex justify-between items-start">
                                <h2 className="flex flex-grow font-body font-bold text-xl">
                                  {t("MakePayment-stepTitle6")}
                                </h2>
                                <div className="font-semibold text-sm whitespace-nowrap">
                                  {t("MakePayment-step2")}
                                </div>
                              </div>
                            </div>
                            <div
                              id="ID_paymentStep2Options"
                              className="pt-4 mt-2 lg:pt-6 border-t border-theme-rule-light"
                            >
                              {currentStep > 1 && (
                                <Disclosure.Panel
                                  className="pb-2 text-sm text-gray-500"
                                  static
                                >
                                  {isOldAlicUlPolicy(selectedPolicy) ? (
                                    <PanelTwo
                                      setCurrentStep={setCurrentStep}
                                      selectedPolicy={selectedPolicy}
                                      loan={loan}
                                      setPaymentType={setPaymentType}
                                      setIsDisabled={setIsDisabled}
                                      setAmount={setAmount}
                                      isStepTwoChecked={isStepTwoChecked}
                                      setStepTwoChecked={setStepTwoChecked}
                                    />
                                  ) : (
                                    <DeprecatedPanelTwo
                                      panelTwoSelection={payment}
                                      setPanelTwoSelection={setPayment}
                                      // dataArray={paymentArray}
                                      selected={selectedPolicy}
                                      register={register}
                                      trigger={trigger}
                                      setValue={setValue}
                                      errors={errors}
                                      handleSubmit={handleSubmit}
                                      setCurrentStep={setCurrentStep}
                                      control={control}
                                      dataSubmit={dataSubmit}
                                      resetField={resetField}
                                      getValues={getValues}
                                      setIsDisabled={setIsDisabled}
                                    />
                                  )}
                                </Disclosure.Panel>
                              )}
                            </div>
                          </>
                        )}
                      </Disclosure>
                    </div>
                  </div>
                </div>

                {/* <!-- Step 3 --> */}
                {!isFlagEnabled(
                  "ENABLE_HIDE_CREDIT_CARD_SELECTION_ON_ONE_TIME_PAYMENT"
                ) && (
                  <div
                    id="ID_paymentStep3"
                    className="flex flex-row md:ml-8 md:mr-0 lg:ml-20 xl:ml-28 lg:pr-16"
                  >
                    <div className="w-8 md:flex md:flex-col md:justify-center md:mr-14">
                      <div className="flex justify-center items-center mt-3 mb-4">
                        <div
                          id="ID_paymentStep3Number"
                          className={`inline-flex justify-center items-center h-8 w-8 text-white ${
                            currentStep >= 3
                              ? "bg-ui-blue-dark"
                              : "bg-ui-gray-medium-dark"
                          } rounded-full overflow-hidden`}
                        >
                          3
                        </div>
                      </div>
                      <div className="flex h-full w-px bg-ui-gray-medium-light mx-auto overflow-hidden"></div>
                    </div>

                    {/* Card 3 */}
                    <div className="w-full flex-grow">
                      <div className="ui-card relative px-4 py-4 mb-6 lg:px-6">
                        <Disclosure as="div">
                          {({ open }) => (
                            <>
                              <div>
                                <div className="flex justify-between items-start">
                                  <h2 className="flex flex-grow font-body font-bold text-xl">
                                    {t("MakePayment-stepTitle7")}
                                  </h2>
                                  <div className="font-semibold text-sm whitespace-nowrap">
                                    {t("MakePayment-step3")}
                                  </div>
                                </div>
                              </div>
                              <div
                                id="ID_paymentStep3Options"
                                className="pt-4 mt-2 lg:pt-6 border-t border-theme-rule-light"
                              >
                                {currentStep > 2 && (
                                  <Disclosure.Panel
                                    className="pb-2 text-sm text-gray-500 items-center"
                                    static
                                  >
                                    <DeprecatedPanelThree
                                      panelThreeSelection={date}
                                      setPanelThreeSelection={setDate}
                                      // dataArray={cardArray}
                                      handleSubmit={handleSubmit}
                                      dataSubmit={dataSubmit}
                                      modalState={addPaymentModal}
                                      setModalState={setAddPaymentModal}
                                      register={register}
                                      setValue={setValue}
                                      setCurrentStep={setCurrentStep}
                                      currentStep={currentStep}
                                      cardData={cardData}
                                      getValues={getValues}
                                      setIsDisabled={setIsDisabled}
                                    />
                                  </Disclosure.Panel>
                                )}
                              </div>
                            </>
                          )}
                        </Disclosure>
                      </div>
                    </div>
                  </div>
                )}

                <div className="block text-right mb-8 md:ml-12 md:mr-6 lg:ml-28 lg:pr-16">
                  <button
                    className="ui-btn-secondary min-w-[140px]"
                    aria-label="cancel make a payment"
                    onClick={() => cancel()}
                  >
                    {t("MakePayment-button1")}
                  </button>
                  <button
                    id="ID_submitPayment"
                    className="ui-btn-primary min-w-[140px]"
                    aria-label="submit payment"
                    disabled={isDisabled}
                    onClick={() => advanceModal()}
                  >
                    {t("MakePayment-button2")}
                  </button>
                </div>
                {/* Modal Dialogs */}
                <AuthorizePaymentNameValidationModal
                  modalState={creditCardValidationCheckModalState}
                  setModalState={setCreditCardValidationCheckModalState}
                  selectedPolicy={selectedPolicy}
                  amount={getValues("amount") ?? amount}
                  setToastDetail={setToastDetail}
                />

                <AuthedCustomerAuthorizePaymentModal
                  modalState={authorizeModal}
                  setModalState={setAuthorizeModal}
                  setConfirmationModal={setConfirmationModal}
                  uid={uid}
                  selectedCard={selectedCard}
                  amount={amount}
                  policyNumber={policyNumber}
                  useCustomerRefNum={useCustomerRefNum}
                  setTxRefNum={setTxRefNum}
                  setProcStatus={setProcStatus}
                  setUserValErrorModalState={setUserValErrorModalState}
                  setErrorTitle={setTitle}
                  setErrorDisc={setDisc}
                  isRequierd={isRequierd}
                  setIsRequierd={setIsRequierd}
                  policies={policies}
                />

                <ConfirmModal
                  modalState={confirmationModal}
                  setModalState={setConfirmationModal}
                  txRefNum={txRefNum}
                  procStatus={procStatus}
                />

                <AddPaymentMethodModal
                  modalState={addPaymentModal}
                  setModalState={setAddPaymentModal}
                  config={config}
                  setConfig={setConfig}
                  onSubmit={onSubmit}
                />

                <DeleteAutopayPaymentModal
                  modalState={deleteAutopayPaymentModal}
                  setModalState={setDeleteAutopayPaymentModal}
                  onSubmit={onSubmit}
                />

                <DeleteNonAutopayPaymentModal
                  modalState={deleteNonAutopayPaymentModal}
                  setModalState={setDeleteNonAutopayPaymentModal}
                  onSubmit={onSubmit}
                />
                <GeneralPurposeDialog
                  state={userValErrorModalState}
                  setState={setUserValErrorModalState}
                  title={title}
                  desc={disc}
                />
              </div>
            </div>
          </div>
        </div>
      </EverlakeLoadingOverlay>
    </>
  );
};

export default DeprecatedMakeAPayment;
